import {nsFetch} from "/assets/js/utils/fetch";
import {notice} from "/assets/js/utils/notices";

class Cart {
    mainContainer;
    qtyBtns;
    delCartItemBtns;
    fillBoxBtns;
    cartTotalContainer;
    cartItems;
    headerCart;

    constructor(elm) {
        this.mainContainer = elm;
        this.init();
        this.initCartTotal();
    }

    init() {
        this.delCartItemBtns = this.mainContainer.querySelectorAll('.cart__item-actions-button-remove');
        this.qtyBtns = this.mainContainer.querySelectorAll('.qty-counter__btn--cart');
        this.fillBoxBtns = this.mainContainer.querySelectorAll('.fill-box');
        this.cartItems = this.mainContainer.querySelector('.cart__items');
        this.headerCart = document.querySelector('.header__actions-cart');

        this.delCartItemBtns.forEach(elm => elm.addEventListener('click', this._delCartItem));
        this.qtyBtns.forEach(elm => elm.addEventListener('click', this._changeCartItemQty));
        this.fillBoxBtns.forEach(elm => elm.addEventListener('click', this._fillBox));
        // Обработчик изменения значения в input
        this.mainContainer.addEventListener('change', this._handleQtyInputChange);
        this.mainContainer.addEventListener('blur', this._handleQtyInputBlur);
        // Обработчик клика на кнопку оформления заказа
        const checkoutButton = this.mainContainer.querySelector('.cart__total-footer-button');
        if (checkoutButton) {
            checkoutButton.addEventListener('click', this._handleCheckoutClick);
        }
    }

    initCartTotal() {
        this.cartTotalContainer = this.mainContainer.querySelector('.cart__total');
        // Переинициализируем обработчик кнопки оформления заказа после обновления
        const checkoutButton = this.cartTotalContainer?.querySelector('.cart__total-footer-button');
        if (checkoutButton) {
            checkoutButton.addEventListener('click', this._handleCheckoutClick);
        }
    } 

    _fillBox = async (e) => {
        e.preventDefault();

        const cartItem = e.target.closest('.cart__item');
        const cartItemCounter = cartItem.querySelector('.qty-counter__value');
        const cartItemSubtotal = cartItem.querySelector('.cart__item-price-value');
        const pricesContainer = cartItem.querySelector('.cart__item-price-desc');

        const data = {
            product_id: cartItem.dataset.productId,
            cart_item_key: cartItem.dataset.cartItemKey
        };

        const response = await nsFetch.doFetch({
            action: 'ns_fill_box',
            body: data
        });

        if (!response.success) {
            notice(
                response.data.message,
                'error'
            );
            return null;
        } else {
            notice(
                response.data.message,
                'success'
            );

            this.cartItems.outerHTML = response.data.cart_items_html;
            this.cartTotalContainer.outerHTML = response.data.cart_total_html;

            this.init();
            this.initCartTotal();
            this.checkCartCoutNineNinePlus(response.data.total_count);
            this._selectCurrentPriceItem(pricesContainer, response.data.item_price);

        }
    }

    _changeCartItemQty = async (e) => {
        e.preventDefault();
        const btn = e.target.closest('.qty-counter__btn');
        const cartItem = e.target.closest('.cart__item');
        const cartItemCounter = cartItem.querySelector('.qty-counter__value');
        const cartItemSubtotal = cartItem.querySelector('.cart__item-price-value');
        const pricesContainer = cartItem.querySelector('.cart__item-price-desc');
        const counter = cartItem.querySelector('[data-counter]');

        const data = {
            productId: cartItem.dataset.productId,
            page: 'cart'
        };
        const action = btn.classList.contains('qty-counter__btn--plus') ? 'ns_add_to_cart' : 'ns_remove_from_cart';

        // Добавляем прелоадер
        if (counter) {
            counter.classList.add('is-loading');
        }

        try {
            const response = await nsFetch.doFetch({
                action: action,
                body: data
            });

            if (!response.success) {
                notice(
                    response.data.message,
                    'error'
                );
                return null;
            } else {
                notice(
                    response.data.message,
                    'success'
                );

                this.cartItems.outerHTML = response.data.cart_items_html;
                this.cartTotalContainer.outerHTML = response.data.cart_total_html;

                this.init();
                this.initCartTotal();

                this.checkCartCoutNineNinePlus(response.data.total_count);
                this._selectCurrentPriceItem(pricesContainer, response.data.item_price);

                if (response.data.total_count < 1) {
                    window.location.reload(true);
                }
            }
        } finally {
            // Убираем прелоадер
            if (counter) {
                counter.classList.remove('is-loading');
            }
        }
    }

    checkCartCoutNineNinePlus(cartCount) {
        if (cartCount > 99) {
            this.headerCart.dataset.cartCount = '99+';
            this.headerCart.classList.add('nine-nine-plus');
        } else {
            this.headerCart.dataset.cartCount = cartCount;
            this.headerCart.classList.remove('nine-nine-plus');
        }
    }

    _selectCurrentPriceItem(parent, price) {
        const prices = parent.querySelectorAll('.cart__item-price-desc-item');
        const curPrice = parent.querySelector('.cart__item-price-desc-item--current');

        if (curPrice) {
            curPrice.classList.remove('cart__item-price-desc-item--current');
        }

        for (const item of prices) {
            if (item.dataset.price == price) {
                item.classList.add('cart__item-price-desc-item--current');
                break;
            }
        }
    }

    _showOverlay = () => {
        if (this.cartItems) {
            this.cartItems.classList.add('cart__items--overlay');
        }
    }

    _hideOverlay = () => {
        if (this.cartItems) {
            this.cartItems.classList.remove('cart__items--overlay');
        }
    }

    _delCartItem = async (e) => {
        e.preventDefault();

        const cartItem = e.target.closest('.cart__item');

        this._showOverlay();

        const response = await nsFetch.doFetch({
            action: 'ns_del_cart_item',
            body: {
                product_id: cartItem.dataset.productId,
                cart_item_key: cartItem.dataset.cartItemKey,
            }
        });

        if (!response.success) {
            notice(
                response.data.message,
                'error'
            );
            this._hideOverlay();
        } else {
            cartItem.remove();

            this.cartItems.outerHTML = response.data.cart_items_html;
            this.cartTotalContainer.outerHTML = response.data.cart_total_html;

            this.init();
            this.initCartTotal();

            this.checkCartCoutNineNinePlus(response.data.total_count);
            this._hideOverlay();
            
            if (response.data.total_count < 1) {
                window.location.reload(true);
            }
        }
        
    }

    _handleQtyInputChange = async (e) => {
        const qtyInput = e.target.closest('[data-qty-input-cart]');
        if (!qtyInput) return;

        e.preventDefault();
        
        const newValue = parseInt(qtyInput.value, 10) || 0;
        const productId = qtyInput.dataset.productId;
        const cartItem = qtyInput.closest('.cart__item');
        const counter = cartItem.querySelector('[data-counter]');
        
        if (!productId || newValue < 0) {
            // Восстанавливаем предыдущее значение
            const oldValue = parseInt(qtyInput.dataset.value, 10) || 0;
            qtyInput.value = oldValue;
            return;
        }

        // Получаем текущее значение из корзины
        const currentValue = parseInt(qtyInput.dataset.value, 10) || 0;

        if (newValue === currentValue) {
            return; // Значение не изменилось
        }

        // Добавляем прелоадер
        if (counter) {
            counter.classList.add('is-loading');
        }
        this._showOverlay();

        try {
            // Используем новый endpoint для установки точного количества
            const response = await nsFetch.doFetch({
                action: 'ns_set_cart_quantity',
                body: {
                    productId: productId,
                    quantity: newValue,
                    page: 'cart'
                }
            });

            if (!response.success) {
                notice(response.data.message, 'error');
                // Восстанавливаем предыдущее значение при ошибке
                qtyInput.value = currentValue;
                return;
            }

            notice(response.data.message, 'success');

            // Обновляем данные корзины
            this.cartTotalContainer.outerHTML = response.data.cart_total_html;
            this.cartItems.outerHTML = response.data.cart_items_html;

            this.init();
            this.initCartTotal();
            
            this.checkCartCoutNineNinePlus(response.data.total_count);

            const productCount = response.data.product_count;

            // Если товар удален из корзины
            if (productCount === 0 || !response.data.line_subtotal) {
                cartItem.remove();
                if (response.data.total_count < 1) {
                    window.location.reload(true);
                }
                return;
            }

            if (response.data.total_count < 1) {
                window.location.reload(true);
            }
        } finally {
            // Убираем прелоадер
            if (counter) {
                counter.classList.remove('is-loading');
            }
            this._hideOverlay();
        }
    }

    _handleQtyInputBlur = (e) => {
        const qtyInput = e.target.closest('[data-qty-input-cart]');
        if (!qtyInput) return;

        // При потере фокуса обновляем data-value текущим значением
        const currentValue = parseInt(qtyInput.value, 10) || 0;
        qtyInput.dataset.value = currentValue;
    }

    _handleCheckoutClick = (e) => {
        const button = e.target.closest('.cart__total-footer-button');
        if (button) {
            button.classList.add('is-loading');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const elm = document.querySelector('.cart__wrapper');
    if (elm) {
        new Cart(elm);
    }
});
